<template>
  <div class="plan" @click="onEditPlan">
    <div class="circular-container">
      <circular-progress :percent="completedPercentage" progress-size="small" size="big" :progress-bar-color="circleColor" />
      <div class="icon-container">
        <img :src="require(`@/assets/plan-ahead/icons/${icon}.svg`)"/>
      </div>
    </div>
    <div class="data-container">
      <div class="name">{{ plan.name }}</div>
      <div class="money-section">
        <span class="large-text bold">{{ currentAmount }} ₪</span>
        <span class="medium-text">מתוך </span>
        <span class="large-text">{{ targetAmount }} ₪</span>
      </div>
      <div class="small-text">עד {{ deadline }}</div>
      <div class="monthly-target-section small-text">{{ monthlyTarget }} שח בחודש</div>
      <plan-status-note :text="noteText" :is-on-track="plan.isOnTrack" :textColor="textColor"/>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import moneyUtils from '@/utils/money';
import CircularProgress
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/action-list/CircularProgress';
import BaseUI from 'base-ui';
import PlansIconsMap from './plans-constanst';
import PlanStatusNote from './PlanStatusNote';

export default {
  name: 'Plan',
  components: {
    PlanStatusNote,
    CircularProgress,
  },
  props: {
    plan: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      circleColor: BaseUI.Colors.riseupBlack,
    };
  },
  computed: {
    deadline() {
      return moment(this.plan.deadline).locale('he').format('MMMM YYYY');
    },
    targetAmount() {
      return moneyUtils.formatAmountWithFraction(this.plan.targetAmount, 0);
    },
    currentAmount() {
      return moneyUtils.formatAmountWithFraction(this.plan.currentAmount, 0);
    },
    monthlyTarget() {
      return moneyUtils.formatAmountWithFraction(this.plan.monthlyTarget, 0);
    },
    noteText() {
      return this.plan.isOnTrack
        ? 'נראה שהכל בכיוון הנכון'
        : 'נראה שלא תגיעו לסכום במועד שרציתם';
    },
    icon() {
      return PlansIconsMap[this.plan.type] || 'general';
    },
    completedPercentage() {
      return (this.plan.currentAmount / this.plan.targetAmount) * 100;
    },
    textColor() {
      return this.plan.isOnTrack ? 'green' : 'red';
    },
  },
  methods: {
    onEditPlan() {
      this.$emit('edit-plan', this.plan);
    },
  },
};
</script>

<style scoped lang="scss">
@import '~base-ui/src/scss/riseup-colors';
  .plan {
    display: flex;
    margin-left: 22px;
    margin-right: 22px;
    padding-top: 22px;
    padding-bottom: 10px;
    box-shadow: 0 5px 10px rgba(186, 188, 191, 0.62);
    border-radius: 8px;
    cursor: pointer;

    .circular-container {
      margin-right: 15px;
      margin-left: 12px;
    }

    .icon-container {
      height: 38px;
      width: 38px;
      display: flex;
      border-radius: 50%;
      background: $riseup_gray_0;
      transform: translate(-9px, -47px);
    }

    .name {
      font-weight: bold;
      font-size: 24px;
      line-height: 32px;
    }
    .large-text {
      font-size: 20px;
    }
    .bold {
      font-weight: bold;
    }
    .medium-text {
      font-size: 16px;
      line-height: 27px;
    }
    .small-text {
      font-size: 14px;
      line-height: 16px;
    }
    .monthly-target-section {
      color: $riseup_gray_2;
      padding-bottom: 9px;
    }
  }

</style>
